import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import { ModalChiTietSoNo } from "./ModalChiTietSoNo";
export const BtnChiTietSoDuNo = ({ item }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false} className="blue btn-link">
        {formatNumber(item.TotalMoney)}
      </a>
      {show && (
        <ModalChiTietSoNo
          show={show}
          onHide={handleClose}
          nhanvien={item.UserName}
        />
      )}
    </>
  );
};
